/*
*
* File JS componente accordion
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './col2_txt_video.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const col2TxtVideo = () => {
    const context = document.querySelectorAll('.col2_txt_video');

    if(!context) return;

    context.forEach(element => {
        const video = element.querySelector('.col2_txt_video__video');
        const videoPlayer = element.querySelector('.col2_txt_video__video > video');

        video.addEventListener('click' , (e) => {
            if (videoPlayer.paused == false) {
                videoPlayer.pause();
                video.classList.remove('video-play');
            } else {
                videoPlayer.play();
                video.classList.add('video-play');
            }
        });
    });

}



export default col2TxtVideo;

//--------------------------------------------------------------------//